import * as React from "react";

import Switch from "@replo/design-system/components/switch/Switch";
import { Tag } from "@replo/design-system/components/tag/Tag";

const BillingIntervalToggle = ({
  isYearly,
  setIsYearly,
  isWorkspaceOnYearlySubscription,
}: {
  isYearly: boolean;
  setIsYearly: (isYearly: boolean) => void;
  isWorkspaceOnYearlySubscription: boolean;
}) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="header-h5">Annual discount</div>
      <Tag size="sm" variant="v2">
        Save 17%
      </Tag>
      <Switch
        size="base"
        isOn={isYearly}
        onChange={(isOn: boolean) => setIsYearly(isOn)}
        trackClassName={isYearly ? "bg-black" : "bg-surface"}
        disabled={isWorkspaceOnYearlySubscription}
        tooltipText={
          isWorkspaceOnYearlySubscription
            ? "You are already on an annual Replo plan"
            : undefined
        }
      />
    </div>
  );
};

export default BillingIntervalToggle;
